import React from 'react';
import { Card, CardContent } from './ui/card';
import { MapPin, Building } from 'lucide-react';

const Zone = () => {
  const zones = [
    {
      department: 'Paris',
      code: '75',
      areas: ['Tous arrondissements', 'Centre historique', 'Périphérie']
    },
    {
      department: 'Hauts-de-Seine',
      code: '92',
      areas: ['Neuilly-sur-Seine', 'Levallois-Perret', 'Boulogne-Billancourt', 'Courbevoie', 'Nanterre']
    },
    {
      department: 'Seine-Saint-Denis',
      code: '93',
      areas: ['Saint-Denis', 'Montreuil', 'Aubervilliers', 'Pantin', 'Bobigny']
    },
    {
      department: 'Val-de-Marne',
      code: '94',
      areas: ['Créteil', 'Vitry-sur-Seine', 'Saint-Maur-des-Fossés', 'Champigny-sur-Marne']
    }
  ];

  return (
    <section id="zone" className="py-24 bg-slate-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="text-emerald-600 font-semibold text-sm uppercase tracking-wider mb-3 block">
            Zone d'Intervention
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Entreprise de rénovation énergétique écologique à Paris et en Île-de-France
          </h2>
          <p className="text-xl text-slate-600">
            VIREO intervient pour les travaux de rénovation intérieure, ravalement de façade et isolation thermique biosourcée dans toute l'Île-de-France
          </p>
        </div>

        {/* Main Coverage Area */}
        <div className="max-w-4xl mx-auto mb-12">
          <Card className="bg-gradient-to-br from-slate-800 to-slate-900 border-none shadow-2xl overflow-hidden">
            <CardContent className="p-8 md:p-12">
              <div className="flex flex-col md:flex-row items-center gap-8">
                <div className="flex-shrink-0">
                  <div className="w-24 h-24 bg-emerald-600 rounded-2xl flex items-center justify-center">
                    <MapPin className="h-12 w-12 text-white" />
                  </div>
                </div>
                <div className="flex-1 text-center md:text-left">
                  <h3 className="text-3xl font-bold text-white mb-3">
                    Siège social : Paris 8ème
                  </h3>
                  <p className="text-xl text-slate-300 mb-2">
                    29 rue Tronchet, 75008 Paris
                  </p>
                  <p className="text-slate-400">
                    Proximité et réactivité garanties pour tous nos clients parisiens et franciliens
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Departments Grid */}
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {zones.map((zone, index) => (
              <Card 
                key={index}
                className="border-slate-200 hover:border-emerald-500 hover:shadow-xl transition-all duration-300 bg-white group"
              >
                <CardContent className="pt-8 pb-8">
                  <div className="text-center">
                    <div className="w-16 h-16 bg-emerald-100 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:bg-emerald-600 transition-colors duration-300">
                      <Building className="h-8 w-8 text-emerald-600 group-hover:text-white transition-colors duration-300" />
                    </div>
                    <div className="mb-4">
                      <h3 className="text-2xl font-bold text-slate-900 mb-1">
                        {zone.department}
                      </h3>
                      <span className="inline-block bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-sm font-semibold">
                        {zone.code}
                      </span>
                    </div>
                    <div className="space-y-2">
                      {zone.areas.map((area, areaIndex) => (
                        <p key={areaIndex} className="text-sm text-slate-600">
                          • {area}
                        </p>
                      ))}
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Additional Info */}
        <div className="max-w-4xl mx-auto mt-12 text-center">
          <Card className="border-emerald-200 bg-emerald-50">
            <CardContent className="py-8">
              <p className="text-lg text-slate-700 mb-4">
                <span className="font-semibold text-slate-900">Vous êtes situé en Île-de-France ?</span> Contactez-nous pour vérifier notre disponibilité dans votre secteur.
              </p>
              <p className="text-sm text-emerald-800 font-medium">
                Mots-clés : Façadier écologique Paris • Rénovation intérieure écologique Paris • Isolation fibre de bois Paris • Enduit chaux intérieur Paris • Rénovation énergétique écologique Paris • ITE biosourcée Île-de-France
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Zone;
